import { gsap, ScrollTrigger, clickNav, fadeUpOnScroll } from '../layout';
import * as challenge from '../components/challenge';

document.addEventListener("DOMContentLoaded", function(){
	clickNav();
	fadeUpOnScroll();
})